
export enum Role{
    User="User",
    Admin="Admin",
    External="External",
    ReadOnly="ReadOnly"
}
